import { navigate } from "gatsby";
import React, { useState } from "react";
import toast from "react-hot-toast";

const Subscription = ({ title }) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = (event) => {
    event.preventDefault();

    setLoading(true);

    const obj = {
      data: {
        email: email,
        date: new Date().toUTCString(),
        website: window.location.origin,
      },
      sheetID: 40,
    };
    fetch("https://leads.civsav.com/template/contact", {
      method: "POST",
      body: JSON.stringify(obj),
      headers: {
        "Content-type": "application/json; charset=UTF-8",
      },
    })
      .then((res) => res.json())
      .then((res) => {
        setLoading(false);
        setEmail("");
        toast.success("Subscribed successfully. Thanks! ");
        navigate("/order");
      })
      .catch(() => {
        toast.error("Something went wrong! Please try again");
        setLoading(false);
      });
  };
  return (
    <div className="w-full">
      <div className="w-full">
        <p className="text-base font-dinnext">{title}</p>
        {/* <div className="klaviyo-form-UZ6byW" id="klaviyo-form"></div> */}
        <div className="w-full flex mt-[13px]">
          <form className="w-full max-w-2xl" onSubmit={onSubmit}>
            <div className="w-full flex flex-row">
              <input
                type="email"
                name="EMAIL"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full h-[51px] sm:h-[58px] bg-white border border-solid border-primary pl-5 py-[19px] text-lg pr-5 font-dinnext font-light"
                id="mce-EMAIL"
                placeholder="Email Address"
                aria-label="Email Address"
              />
              <button
                type="submit"
                disabled={loading}
                className="w-fit h-[51px] sm:h-[58px] bg-primary text-lg font-dinnext font-medium px-[14px] sm:px-[55px]"
              >
                <span className="text-white">Subscribe</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Subscription;
